<template>
  <div>
    <div v-on:click="showRules = !showRules" style="cursor: pointer">
      <p>
        <icon type="iconfont icon-vaild" class="icon-iconfont" color="#999" style="margin-right: 6px" size="16"></icon>
        <a>
          <Icon type="md-arrow-dropright" size="16" v-if="!showRules" color="#999" style="line-height: 19px" />
          <Icon type="md-arrow-dropdown" size="16" v-if="showRules" color="#999"  style="line-height: 19px" />
          <span style="font-size: 13px;">{{ info.name }}</span>
        </a>
      </p>
      <span style="margin-left: 38px; color: #999" v-if="info.description">{{ info.description }}</span>
    </div>
    <a style="position: absolute; right: 50px; top: 15px;" v-on:click="openRuleView">管理规则</a>
    <div style="margin-top: 10px" v-if="showRules">
      <SecurityGroupRuleList :security_group_id="info.id" class="server-security-group-rule-list"></SecurityGroupRuleList>
    </div>
  </div>
</template>

<script>
import SecurityGroupRuleList from '@/view/private-cloud/net/components/security-group-rule-list'

export default {
  name: 'server-security-group-info',
  components: {
    SecurityGroupRuleList
  },
  props: {
    info: {
      type: Object
    }
  },
  data () {
    return {
      showRules: false
    }
  },
  methods: {
    openRuleView () {
      this.$router.push({ name: 'security_group_rule', params: { id: this.info.id }, query: { name: this.info.name } })
    }
  }
}
</script>

<style lang="less">
  .server-security-group-rule-list {
    .ivu-table, .ivu-table th, .ivu-table td {
      background-color: #FFF;
    }
  }
</style>
